import Box from '@mui/material/Box';
import { isEmpty, isNil } from 'lodash';
import { SingleTemplateDropdownProps } from 'types/Dialog.types';

import TemplateSelector from './TemplateSelector';

/**
 * Renders template and mapping selectors with block headers for single template configuration
 */
const SingleTemplateDropdown = ({
  selectedTemplate,
  selectedMapping,
  templateOptions,
  mappingOptions,
  templateDisabled,
  onTemplateChange,
  onMappingChange,
  numberOfBlockHeaders,
  blockHeaders,
  onBlockHeaderChange,
  blockHeaderOptions,
}: SingleTemplateDropdownProps) => {
  // For tracking whether a valid template has been selected by the User
  const hasSelectedTemplate = !isNil(selectedTemplate) && !isEmpty(selectedTemplate);

  return (
    <Box>
      <Box className='template-container first-template-row'>
        <TemplateSelector
          label='Column Template'
          value={selectedTemplate}
          options={templateOptions}
          onChange={onTemplateChange}
          className='column-template-section'
          disabled={templateDisabled}
        />
        <TemplateSelector
          label='Column Mapping'
          value={selectedMapping}
          options={mappingOptions}
          onChange={onMappingChange}
          className='column-mapping-section'
          disabled={!hasSelectedTemplate}
        />
      </Box>
      {blockHeaders && onBlockHeaderChange && (
        <Box className='block-headers-container'>
          {Array.from({ length: numberOfBlockHeaders }, (_, index) => {
            const headerNumber = index + 1;
            const headerKey = `blockHeader${headerNumber}` as keyof typeof blockHeaders;
            const setterKey = `setBlockHeader${headerNumber}` as keyof typeof onBlockHeaderChange;

            return (
              <TemplateSelector
                key={headerNumber}
                label={`Block Header ${headerNumber}`}
                value={blockHeaders[headerKey] || ''}
                options={blockHeaderOptions || []}
                onChange={(value) => onBlockHeaderChange[setterKey](value)}
                className='block-header-dropdown'
                disabled={!hasSelectedTemplate}
              />
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default SingleTemplateDropdown;
